<template>
  <div class="flex items-center gap-2">
    <slot></slot>
    <Icon
      class="cursor-pointer !text-blue"
      :class="{ 'opacity-50 !cursor-not-allowed': props.disabled }"
      icon="ion:language"
      @click="handleTrigger"
    />
  </div>
</template>
<script setup name="AppLangInjector">
  import md5 from 'crypto-js/md5'
  import { Icon } from 'framework/components/Icon'
  import { useMessage } from 'framework/hooks/web/useMessage'
  import { uniqueId } from 'lodash-es'
  const props = defineProps({
    field: String,
    content: String,
    persist: {
      type: Boolean,
      default: false,
    },
    richText: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  })

  const { createMessage } = useMessage()
  const { addField, delField, onTrigger } = inject('__APP_LANG__')
  const fieldId = uniqueId()

  const getContent = () => ({
    contentId: md5(`${props.field}:${props.content}`).toString(),
    content: props.content,
    field: props.field,
    richText: props.richText,
  })

  const handleTrigger = () => {
    if (props.disabled) {
      return
    }
    if (!props.content) {
      createMessage.error('翻译的内容不能为空')
      return
    }
    onTrigger(getContent())
  }

  onMounted(() => addField(fieldId, getContent))
  onUnmounted(() => !props.persist && delField(fieldId))
</script>
